import React from "react";
import { observer } from "mobx-react-lite";
import { useStore } from "stores/Stores";
import styles from "./goalsCard.module.scss";
import { Loader } from "ecom-teams-apps-core";
import pl from "shared/messages/pl";
import { constants } from "shared/constants";
import { ScoreReportType } from "./store/ScoreReportType";
import { BusinessRole } from "shared/enums/BusinessRole";
import ReportsPresenter, { ReportsPresenterProps, ReportTypeWithPeriods } from "./ReportsPresenter";
import { useQuery } from "react-query";
import ScoresService from "./service/ScoresService";
import { PeriodType } from "shared/service/api/generated";

export interface GoalsCardProps {
    activeTab?: number;
}

const GoalsCard: React.FC<GoalsCardProps> = observer((props: GoalsCardProps) => {
    const { authorizationStore } = useStore();

    const { isFetching, data } = useQuery(["goals-card-periods"], async () => {
        const [monthlyPeriods, quarterlyPeriods] = await Promise.all([
            ScoresService.getPeriods(PeriodType.MONTHLY),
            ScoresService.getPeriods(PeriodType.QUARTERLY),
        ]);

        return { monthlyPeriods, quarterlyPeriods };
    });

    const renderLoader = () => {
        return (
            <div className={styles.loaderWrapper}>
                <Loader text={pl.reports.loading} />
            </div>
        );
    };

    const getReportsPresenterProps = (): ReportsPresenterProps => {
        const availableReportsWithPeriods: ReportTypeWithPeriods[] = [];

        availableReportsWithPeriods.push({
            scoreReportType: ScoreReportType.MONTHLY,
            tab: constants.reportTabs.monthly,
            periods: data?.monthlyPeriods ?? [],
        });

        if (authorizationStore.currentUser?.businessRole !== BusinessRole.MS) {
            availableReportsWithPeriods.push({
                scoreReportType: ScoreReportType.QUARTERLY,
                tab: constants.reportTabs.quarterly,
                periods: data?.quarterlyPeriods ?? [],
            });
        }

        if (authorizationStore.currentUser?.businessRole === BusinessRole.HQ) {
            availableReportsWithPeriods.push({
                scoreReportType: ScoreReportType.MONTHLY_RMS,
                tab: constants.reportTabs.monthly_rms,
                periods: data?.monthlyPeriods ?? [],
            });
        }

        let activeTab = ScoreReportType.MONTHLY;
        switch (props.activeTab) {
            case ScoreReportType.MONTHLY_RMS:
                activeTab = ScoreReportType.MONTHLY_RMS;
                break;
            case ScoreReportType.QUARTERLY:
                activeTab = ScoreReportType.QUARTERLY;
                break;
            default:
                break;
        }

        return {
            availableReportsWithPeriods: availableReportsWithPeriods,
            activeTab: activeTab,
        };
    };

    if (isFetching) {
        return renderLoader();
    }

    return <ReportsPresenter {...getReportsPresenterProps()} />;
});

export default GoalsCard;
